// eslint-disable-next-line no-unused-vars
import axios from 'axios'
// eslint-disable-next-line no-unused-vars
import { config, url } from '../../index'

const state = () => ({
  isLoading: false,
  tableList: [
    {
      id: 1,
      title: 'Принятые',
      isActive: false
    },
    {
      id: 2,
      title: 'Уволенные',
      isActive: false
    },
    {
      id: 3,
      title: 'Подразделение',
      isActive: true
    }
  ]
})

const getters = {
  usersReportIsLoading: state => state.isLoading,
  usersReportTableList: state => state.tableList
}

const mutations = {
  TOGGLE_ASIDE_NOTIFICATION_WIDGET: (state) => {
    state.active = !state.active
  }
}

const actions = {
  closeNotificationWidget ({ commit }) {
    commit('CLOSE_ASIDE_NOTIFICATION_WIDGET')
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
